import React, {createRef} from "react"

import MenuItem from "./menu-item"
import MenuHelp from "./menu-help"
import ViewTemplates from "../../../../../../../core/manager/view-templates/view-templates"
import ProjectView from "../../../../../../../core/model2/project-view/project-view"
import {ProjectViewAccess} from "../../../../../../../core/model2/project-view/@const"
import PopoverMenuHeader from "../../../../../../../core/gd-components/popover-menu/popover-menu/popover-menu-header";

type Props = {
    className?  : string
    menuParams  : {
        view : ProjectView
    }
    hidePopover : func
}

// const debug = "ProjectView_MoreMenu"
const debug = false

export default class ProjectView_MoreMenu extends React.Component<Props> {

    private refInfo         : any       = createRef()

    private fullAccess      : boolean

    constructor(props: Props) {
        super(props)

        this.fullAccess     = this.props.menuParams.view.projectViews.project.acl.hasFullAccess
    }

    onSetAsDefault =  () => {
        this.props.hidePopover()
        gd.projectViews.setDefaultView(this.props.menuParams.view)
    }

    onSaveAsTemplate = () => {
        this.props.hidePopover()

        const baseView = this.props.menuParams.view

        gd.modals.newViewTemplate(baseView.name + ' template', baseView.systemType, values=>{
            if (values.templateId) { // override existing
                const template = new ViewTemplates().editTemplateFromProjectView(values.templateId, null, null, baseView, baseView.systemType)
                // this.applyTemplate(template)
            } else { // add new
                const newTemplate = new ViewTemplates().addTemplateFromProjectView(values.name, values.access, baseView, baseView.systemType)
                // this.applyTemplate(newTemplate)
            }
        })
    }

    onLoadTemplate = () => {
        this.props.hidePopover()

        const baseView = this.props.menuParams.view
        // const {companyId} = gd.session.projects.get(gd.projectViews.project.id)
        gd.modals.loadViewTemplate(gd.companyId, baseView.systemType, template=>{
            template.appSettings.templateId = template.id
            baseView.saveAppSettings(template.appSettings)

            // refresh view if currentView is updated
            if (baseView.id === gd.projectViews.currentView.id) {
                gd.goTo(baseView.url)
            }
        })
    }

    onEdit = async () => {
        this.props.hidePopover()
        this.props.menuParams.view.edit()
    }

    onCopyUrl = () => {
        this.props.hidePopover()
        this.props.menuParams.view.copyUrl()
    }

    onRename = async () => {
        this.props.hidePopover()
        await this.props.menuParams.view.rename()
    }

    onDuplicate = () => {
        this.props.hidePopover()

        const baseView = this.props.menuParams.view
        gd.modals.project.newProjectView(baseView.projectViews.project.id, baseView.name + ' copy', (values: any)=>{
            gd.projectViews.duplicate(this.props.menuParams.view, {
                name    : values.name,
                access  : values.access
            })
        })
    }

    onReset = () => {
        this.props.hidePopover()
        gd.projectViews.resetAppSettings(this.props.menuParams.view)
    }

    onDelete = () => {
        this.props.hidePopover()
        gd.projectViews.delete(this.props.menuParams.view)
    }

    onMoveRight = () => {
        debug && console.log(debug, "onMoveRight")
        this.props.hidePopover()
        gd.projectViews.moveRight(this.props.menuParams.view)
    }

    onMoveLeft = () => {
        debug && console.log(debug, "onMoveLeft")
        this.props.hidePopover()
        gd.projectViews.moveLeft(this.props.menuParams.view)
    }

    setPermission = (access: ProjectViewAccess) => {
        debug && console.log(debug, "Set permission access=", access)

        const projectView : ProjectView = this.props.menuParams.view as unknown as ProjectView

        this.props.hidePopover()

        projectView.setAccess(access)
    }

    // set help message
    onSetInfoMessage = (message: any) => {
        this.refInfo.current.setMessage(message)
    }

    renderTemplates() {

        return null

        const {view} = this.props.menuParams

        if (!view.acl.canSaveAsTemplate && !view.acl.canLoadTemplate) return false

        return (
            <>
                <div className="separator"/>

                {view.acl.canSaveAsTemplate &&
                    <MenuItem icon              ="i5-save"
                              label             = "Save as template"
                              infoMessage       = "Save view layout as template"
                              onClick           = {this.onSaveAsTemplate}
                              onSetInfoMessage  = {this.onSetInfoMessage}/>}

                <MenuItem label             = "Load from template"
                          infoMessage       = "Load and apply layout template to this view"
                          onClick           = {this.onLoadTemplate}
                          onSetInfoMessage  = {this.onSetInfoMessage}
                          disabled          = {!this.fullAccess}/>
            </>
        )
    }

    renderMove() {
        const moveRightDisabled         = this.props.menuParams.view.isLast
        const moveLeftDisabled          = this.props.menuParams.view.isFirst

        return (
            <>
                <MenuItem label             = "Move Left"
                          icon              = "i5-long-arrow-left"
                          infoMessage       = "Move menu item one position left"
                          onClick           = {this.onMoveLeft}
                          onSetInfoMessage  = {this.onSetInfoMessage}
                          disabled          = {moveLeftDisabled} />

                <MenuItem label             = "Move Right"
                          icon              = "i5-long-arrow-right"
                          infoMessage       = "Move menu item one position right"
                          onClick           = {this.onMoveRight}
                          onSetInfoMessage  = {this.onSetInfoMessage}
                          disabled          = {moveRightDisabled} />

                <div className="separator"/>
            </>
        )
    }

    renderPermissions() {
        const {view} = this.props.menuParams

        const setPublicAccessMessage = view.acl.canSetPublicPermission ?
            "Set public access" : "Only full access user can set public access"

        return (
            <>
                <PopoverMenuHeader title="Permissions" />

                <MenuItem className         = {Classes({selected: view.access===ProjectViewAccess.PUBLIC})}
                          icon              = "i5-users" label="Public"
                          infoMessage       = {setPublicAccessMessage}
                          disabled          = {!view.acl.canSetPublicPermission}
                          onClick           = {()=>this.setPermission(ProjectViewAccess.PUBLIC)}
                          onSetInfoMessage  = {this.onSetInfoMessage}/>

                <MenuItem className         = {Classes({selected: view.access===ProjectViewAccess.PRIVATE})}
                          icon              = "i5-lock"
                          label             = "Private"
                          infoMessage       = "Set private access"
                          onClick           = {()=>this.setPermission(ProjectViewAccess.PRIVATE)}
                          onSetInfoMessage  = {this.onSetInfoMessage}/>

                <div className="separator"/>
            </>
        )

    }

    render() {
        const {view} = this.props.menuParams

        const showRename                = view.acl.canRename
        const showCopyURL               = view.acl.canCopyURL
        const showEdit                  = view.acl.canEditSource
        const showDuplicate             = view.acl.canDuplicate
        // const showResetToDefault        = view.acl.canResetToDefault
        const showEditPermissions       = view.acl.canEditPermissions
        const showSetAsToDefault        = view.acl.canSetAsToDefault
        // const showTemplates             = view.acl.canSaveAsTemplate || view.acl.canLoadTemplate

        const setAsDefaultDisabled      = !this.fullAccess || view.id === gd.projectViews.getDefaultView({checkLocalSettings: false}).id

        const showEditSeparator         = showRename || showEdit || showDuplicate || showCopyURL || showSetAsToDefault
        // const showPermissionsSeparator  = showCopyURL || showDuplicate || showResetToDefault

        const classes = Classes("ui5-popover-menu with-help", this.props.className)

        return (
            <div className={classes}>

                {showEdit &&
                    <MenuItem icon              = "i5-embeded-code"
                              label             = "Edit source"
                              infoMessage       = "Edit view source"
                              onClick           = {this.onEdit}
                              onSetInfoMessage  = {this.onSetInfoMessage}/>}

                {showRename &&
                    <MenuItem icon              = "i5-pen"
                              label             = "Rename"
                              infoMessage       = "Rename view"
                              onClick           = {this.onRename}
                              onSetInfoMessage  = {this.onSetInfoMessage}/>}

                {showDuplicate &&
                    <MenuItem icon              = "i5-clone"
                              label             = "Duplicate"
                              infoMessage       = "Duplicate view"
                              disabled          = {!view.acl.canDuplicate}
                              onClick           = {this.onDuplicate}
                              onSetInfoMessage  = {this.onSetInfoMessage}/>}

                {showCopyURL &&
                    <MenuItem icon              = "i5-copy-link"
                              label             = "Copy URL"
                              infoMessage       = "Copy view URL to clipboard"
                              onClick           = {this.onCopyUrl}
                              onSetInfoMessage  = {this.onSetInfoMessage}/>}


                {showSetAsToDefault &&
                    <MenuItem label             = "Set as default view"
                              icon              = "i5-flag"
                              infoMessage       = "Set as default view for this folder"
                              onClick           = {this.onSetAsDefault}
                              onSetInfoMessage  = {this.onSetInfoMessage}
                              disabled          = {setAsDefaultDisabled} />
                    }

                {showEditSeparator && <div className="separator"/>}

                {/*{showResetToDefault &&*/}
                {/*    <MenuItem icon              = "i5-reset"*/}
                {/*              label             = "Reset to defaults"*/}
                {/*              infoMessage       = "Reset view settings to default values"*/}
                {/*              onClick           = {this.onReset}*/}
                {/*              onSetInfoMessage  = {this.onSetInfoMessage}/>}*/}




                {/*{showTemplates && this.renderTemplates()}*/}
                {/*<div className="separator"/>*/}

                {this.renderMove()}

                {showEditPermissions && this.renderPermissions()}



                <MenuItem icon              = "i5-trash-alt"
                          label             = "Delete"
                          infoMessage       = "Delete view"
                          onClick           = {this.onDelete}
                          onSetInfoMessage  = {this.onSetInfoMessage}
                          disabled          = {!view.acl.canDelete}/>

                <MenuHelp ref               = {this.refInfo}
                          defaultMessage    = "Mouse over menu item for help" />
            </div>
        )
    }
}
